import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import ImageTool from "./pages/ImageTool";
import SitemapTool from "./pages/SitemapTool";

function App() {
  return (
    <Router>
      <div style={{ padding: 20 }}>
        <nav style={{ marginBottom: 20 }}>
          <Link to="/" className="btn btn-primary" style={{ marginRight: 20 }}>Image Tool</Link>
          <Link to="/sitemap" className="btn btn-primary">Sitemap Generator</Link>
        </nav>

        <Routes>
          <Route path="/" element={<ImageTool />} />
          <Route path="/sitemap" element={<SitemapTool />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;